import React from 'react';
import css from './css.module.less';

import { DragNDrop } from '@/src/components';
import ErrorProcessingComponent from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/ErrorProcessingComponent';
import classname from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'src/components/CloneButton';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getContentPageList,
  getMegaMenus,
  getNavigationList,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onMegaMenuChange,
  onMegaMenuLinkModuleChange,
  onMegaMenuTitleChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/slice';
import { validateMegaMenu } from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/tools';
import { i18nGet } from 'src/tools/tools';
import { EnumContentPageStatus } from 'src/types/common/SalesChannel';
import { ActionType } from 'src/types/common/common';
import Menu from './Menu';
const MenuList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary } = props;
  const contentPages = useSelector(getContentPageList()) || [];

  const validContentPages = contentPages.filter(
    (i) => i.status === EnumContentPageStatus.InUse,
  );
  const navigationList = useSelector(getNavigationList());
  const d = useDispatch();
  const data = useSelector(getMegaMenus());
  //
  //

  const handleOnMenuAdd = () => {
    d(onMegaMenuChange({ type: ActionType.add }));
  };

  const handleOnTitleChange = (index, title) => {
    d(
      onMegaMenuTitleChange({
        title,
        index,
      }),
    );
  };

  const handleOnLinkModuleChange = (index, linkModule) => {
    d(
      onMegaMenuLinkModuleChange({
        linkModule,
        index,
      }),
    );
  };

  const handleOnTypeChange = (index, colIndex, target) => {
    //console.log(index, colIndex, target);
    d(onMegaMenuChange({ type: ActionType.modify, target, index, colIndex }));
  };

  const handleOnContentPageChange = (index, colIndex, target) => {
    d(onMegaMenuChange({ type: ActionType.modify, target, index, colIndex }));
  };

  const handleOnNavigationChange = (index, colIndex, target) => {
    d(onMegaMenuChange({ type: ActionType.modify, target, index, colIndex }));
  };

  const handleOnProductChange = (index, colIndex, target) => {
    d(onMegaMenuChange({ type: ActionType.modify, target, index, colIndex }));
  };

  const handleOnOrderOnChange = (newIndex: number, oldIndex: number) => {
    d(
      onMegaMenuChange({
        type: ActionType.reorder,
        from: oldIndex,
        to: newIndex,
      }),
    );
  };

  const renderChild = (menu, provided, index) => {
    return (
      <ErrorProcessingComponent
        key={menu.draggableId}
        id={menu.draggableId}
        expandOffset={0}
        data={menu}
        title={menu.title}
        collapseProps={{
          titleContainerClassName: isPrimary ? css.draggableContainer : '',
          collapseComponentTitleProps: {
            ...provided.dragHandleProps,
            // style: {
            //   boxShadow: '-4px 0px 0px 0px rgba(0,0,0,1)',
            //   // backgroundColor: 'red'
            // },
          },
        }}
        getErrorDisplay={getCollapseValidationMsgDisplay}
        onErrorChange={onErrorChange}
        getCollapseOpenStatus={getCollapseOpenStatus}
        onCollapseOpen={onCollapseOpen}
        getSubmitStamp={getSubmitStamp}
        validation={(x, _p) => {
          const err = validateMegaMenu(x, validContentPages);
          return err;
        }}
        headerProps={{
          dotsFunction: [
            {
              key: 'Delete',
              body: getI18n('general.delete'),
              isDangerous: true,
              displayWarningModal: true,
              onClick: () => void 0,
              modalOnOk: () => {
                const id = menu.draggableId;
                d(
                  onMegaMenuChange({
                    type: ActionType.delete,
                    draggableId: id,
                    index,
                  }),
                );
              },
              modalTitle: getI18n('salesChannelContent.index.deleteMegaMenu'),
              modalContent: getI18n(
                'salesChannelContent.index.deleteMegaMenuContent',
              ),
            },
          ],
          hasDots: true,
          hideDotsWhenNotPrimary: true,
        }}
        renderComponent={(error) => {
          //console.log('error', error);
          //console.log('menu', menu);
          return (
            <Menu
              isPrimary={isPrimary}
              id={menu.draggableId}
              contentPages={validContentPages}
              navigationList={navigationList}
              error={error.specificError || {}}
              data={menu}
              onTitleChange={(title) => {
                handleOnTitleChange(index, title);
              }}
              onLinkModuleChange={(link) => {
                handleOnLinkModuleChange(index, link);
              }}
              onTypeChange={(colIndex, type) => {
                handleOnTypeChange(index, colIndex, { columnType: type });
              }}
              onContentPageChange={(colIndex, target) => {
                handleOnContentPageChange(index, colIndex, target);
              }}
              onNavigationChange={(colIndex, target) => {
                //console.log('target', target);
                handleOnNavigationChange(index, colIndex, target);
              }}
              onProductChange={(colIndex, target) => {
                //console.log(colIndex, target);
                handleOnProductChange(index, colIndex, target);
              }}
            />
          );
        }}
      />
    );
  };

  return (
    <React.Fragment>
      {isPrimary && (
        <Button
          className={classname(css.fieldSection)}
          buttonText={`+ ${getI18n('salesChannelContent.index.newMenu')}`}
          onClick={handleOnMenuAdd}
          avoidAlert
        />
      )}

      <div className={classname(css.fieldSection2)}>
        <DragNDrop
          disableAllDrags={!isPrimary}
          droppableId={'SalesChannelMegaMenuDropArea'}
          //disableAllDrags={disabled}
          list={data}
          childGenerator={renderChild}
          onChange={handleOnOrderOnChange}
        />
      </div>
    </React.Fragment>
  );
};

export default MenuList;
